import template from './acris-faq-document.html.twig';
import './acris-faq-document.scss';

const { Component } = Shopware;

/**
 * @private
 * @description Component which renders an image.
 * @status ready
 * @example-type code-only
 * @component-example
 * <sw-image :item="item" isCover="true"></sw-image>
 */
Component.register('acris-faq-document', {
    template,

    emits: ['acris-faq-document-edit', 'acris-faq-document-delete'],

    props: {
        mediaId: {
            type: String,
            required: true
        },

        isCover: {
            type: Boolean,
            required: false,
            default: false
        },

        isPlaceholder: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        faqImageClasses() {
            return {
                'is--placeholder': this.isPlaceholder,
                'is--cover': this.isCover
            };
        }
    }
});
